import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';


const BlogCard1 = ({ id, title, description, date, image, loading }) => {
  return (
    <div className="blog-card">
      <div className="card-image">
       
          <Skeleton height={200} />
       
      </div>

      <div className="blog-content">
        
          <Skeleton width="30%" height="25px" />
         
         
         <div className="blog-content-el mt-3">
         
          <Skeleton width="75%" height="25px" style={{marginTop:"5px"}}/>
      
        <Skeleton width="90%" height="25px" style={{marginTop:"5px"}}/>
        <Skeleton width="60%" height="25px" style={{marginTop:"5px"}}/>
        <Skeleton width="80%" height="15px" style={{marginTop:"10px"}}/>
       <Skeleton width="80%" height="15px" />
          <Skeleton  width="20%" height="30px"  style={{marginTop:"10px"}}/>
        
         </div>


      
      </div>
    </div>
  );
};

export default BlogCard1;
